export default {
  icon: 'comment',
  name: 'Echanges',
  noItems: "Il n'y a pas encore d'échanges",
  description: 'Description',
  create: {
    validate: 'Créer',
    author: 'Destinataire',
    nodt_date: 'Date de début requise',
    notype: 'Type requis',
    title: "Ajout d'une étape d'échange",
    description: 'Description',
    type: 'Type',
    icon: 'add',
    btnText: "Ajout d'une étape d'échange",
    authorType: 'Groupe',
    noauthor: 'Destinataire requis',
    logbook: 'Ajouter un lien Journal de bord',
    selectedLogbook: "Selectionner un évènement à référencer dans l'échange",
  },
  update: {
    validate: 'Mettre à jour',
    icon: 'edit',
    btnText: '',
    title: "Modifier l'échange",
    logbook: 'Modifier le lien Journal de bord',
  },
  delete: {
    validate: 'Supprimer cet échange ?',
    title: "Supprimer l'échange",
    icon: 'delete',
  },
  item: {
    noItems: 'Echange introuvable',
  },
};
